import api from 'api/api'
import { toast } from 'react-toastify'

import { API_URL } from 'constants/index'

export const GET_PROVIDER_LETTERS = "[PROVIDER CREDIT LETTERS] GET PROVIDER LETTERS"

export const GET_PROVIDER_CREDIT_LETTERS = "[PROVIDER CREDIT LETTERS] GET PROVIDER CREDIT LETTERS"

export const CRUD_PROVIDER_CREDIT_LETTER = "[PROVIDER CREDIT LETTERS] SAVE PROVIDER CREDIT LETTER"

export const FINISH_REGISTER_PROVIDER_CREDIT_LETTERS = "[PROVIDER CREDIT LETTERS] FINISH REGISTER PROVIDER CREDIT LETTERS"

export function getProviderLetters(
  { page = 1, pageSize = 10, providerId = 0, startDate = '', endDate = '', status = '', search = '', }
) {
  const request = api.get(`/letra-credito-proveedor/obtener-letras-proveedor`, {
    params: {
      page,
      por_pagina: pageSize,
      proveedor_id: providerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: GET_PROVIDER_LETTERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PROVIDER_LETTERS, payload: { loading: false, ...response.data } })
    }).catch((error) => {
      dispatch({ type: GET_PROVIDER_LETTERS, payload: { loading: false } })
      console.log(error);
    })
  }
}

export function getProviderCreditLetters({ creditId = 0, status = '' }) {
  const request = api.get(
    `/letra-credito-proveedor/obtener-letras-credito`, {
    params: {
      idcredito: creditId,
      estado: status,
    }
  })
  return (dispatch) => {
    dispatch({ type: GET_PROVIDER_CREDIT_LETTERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PROVIDER_CREDIT_LETTERS, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_PROVIDER_CREDIT_LETTERS, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_PROVIDER_CREDIT_LETTERS, payload: { loading: false, data: null } })
      toast.error("Error al obtener las letras de crédito")
      console.log(error)
    })
  }
}

export function generateProviderCreditLetters(form) {
  const request = api.post(`/letra-credito-proveedor/generar-letras`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: true } })
    request.then((response) => {
      if (response.data.status === 400) {
        dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
      toast.error("Error al generar las letras de crédito")
      console.log(error)
    })
  }
}

export function saveProviderCreditLetter(from) {
  const request = api.post(`/letra-credito-proveedor/guardar-letra`, from)
  return (dispatch) => {
    dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: true } })
    request.then((response) => {
      if (response.data.status === 400) {
        dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }

      dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: true } })
      toast.success(response.data.message)

      setTimeout(() => {
        dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
      }, 50)

    }).catch((error) => {
      dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
      toast.error("Error al guardar la letra")
      console.log(error)
    })
  }
}

export function deleteProviderCreditLetter(from) {
  const request = api.post(`/letra-credito-proveedor/eliminar-letra`, from)
  return (dispatch) => {
    dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: true } })
    request.then((response) => {
      if (response.data.status === 400) {
        dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_PROVIDER_CREDIT_LETTER, payload: { loading: false, crud: false } })
      toast.error("Error al eliminar la letra")
      console.log(error)
    })
  }
}

export function finishRegisterProviderCreditLetters(from) {
  const request = api.post(`/letra-credito-proveedor/finalizar-registro-letras`, from)
  return (dispatch) => {
    dispatch({ type: FINISH_REGISTER_PROVIDER_CREDIT_LETTERS, payload: { loading: true } })
    request.then((response) => {
      if (response.data.status === 400) {
        dispatch({ type: FINISH_REGISTER_PROVIDER_CREDIT_LETTERS, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_REGISTER_PROVIDER_CREDIT_LETTERS, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: FINISH_REGISTER_PROVIDER_CREDIT_LETTERS, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: FINISH_REGISTER_PROVIDER_CREDIT_LETTERS, payload: { loading: false, crud: false } })
      toast.error("Error al finalizar el registro de letras")
      console.log(error)
    })
  }
}